module.exports = __webpack_public_path__ + "img/southeast-winter-768x550.ee266339.jpg";